import { Button, Card, Tabs } from 'antd'
import { CardTitle, IntakeDataContainer, IntakeTitleContainer, ResultContainer } from './style'
import { useMemo, useState } from 'react';
import { ClientQuestionnaireType } from '../../types';
import MaterialIcon from '../Icons/MaterialIcon';
import { formatDate } from '../../helpers';
import { useNavigate } from 'react-router-dom';
import NewAIQuestionnaireClient from './NewAI/Client/NewAIQuestionnaireClient';

interface QuestionnaireProps {
  questionnaireAssignments: ClientQuestionnaireType[];
  client: any;
}

const Questionnaire: React.FC<QuestionnaireProps> = ({ questionnaireAssignments, client }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('1');

  const modifiedQuestionnairesList = useMemo(() => {
    const groupedData: { [key: string]: ClientQuestionnaireType[] } = {};

    questionnaireAssignments?.forEach((data: ClientQuestionnaireType) => {
      const groupKey = data.questionnaire.group === 'intake'
        ? 'intake'
        : 'addtlQuestionnaires';

      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }

      groupedData[groupKey].push({
        ...data,
      });
    });

    return groupedData;
  }, [questionnaireAssignments]);

  const intakeNotEmpty = useMemo(() => {
    return questionnaireAssignments?.some(
      (assignment: any) => assignment.questionnaire.group === "intake"
    );
  }, [questionnaireAssignments]);

  const addtlQuestionnairesNotEmpty = useMemo(() => {
    return questionnaireAssignments?.some(
      (assignment: any) => assignment.questionnaire.group === ""
    );
  }, [questionnaireAssignments]);

  const onVisitNewQuestionnaire = (questionnaireId: string) => {
    navigate(`questionnaires/${questionnaireId}/new`);
  };

  return (
    <Card>
      <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Questionnaires" key="1">
          <IntakeTitleContainer>
            <p>Intake</p>
          </IntakeTitleContainer>
          <IntakeDataContainer>
            {intakeNotEmpty && (
              <tbody>
                {modifiedQuestionnairesList?.intake?.map((data: ClientQuestionnaireType, index: number) => (
                  <tr key={data.id}>
                    <td>{data.questionnaire.title}</td>
                    <td>{formatDate(data.updatedAt)}</td>
                    <td>
                      <ResultContainer>
                        {data.response ? (
                          <>
                            <Button type="text" icon={<MaterialIcon className="material-icons-sharp" icon="visibility" />}>
                              Resultaten
                            </Button>
                            {/* <i className="material-icons-sharp">visibility</i>
                        <p>Resultaten</p> */}
                          </>
                        ) : (
                          <>
                            <Button onClick={() => onVisitNewQuestionnaire(data.id)} type="text" icon={<MaterialIcon className="material-icons-sharp" icon="play_arrow" />}>
                              Start
                            </Button>
                          </>
                        )}
                      </ResultContainer>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </IntakeDataContainer>
          <IntakeTitleContainer>
            <p>Additional questionnaires</p>
          </IntakeTitleContainer>
          <IntakeDataContainer>
            {addtlQuestionnairesNotEmpty && (
              <tbody>
                {modifiedQuestionnairesList?.addtlQuestionnaires?.map((data: ClientQuestionnaireType, index: number) => (
                  <tr key={data.id}>
                    <td>{data.questionnaire.title}</td>
                    <td>{formatDate(data.updatedAt)}</td>
                    <td>
                      <ResultContainer>
                        {data.response ? (
                          <>
                            <Button type="text" icon={<MaterialIcon className="material-icons-sharp" icon="visibility" />}>
                              Resultaten
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button type="text" icon={<MaterialIcon className="material-icons-sharp" icon="play_arrow" />}>
                              Start
                            </Button>
                          </>
                        )}
                      </ResultContainer>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </IntakeDataContainer>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Biocoherence Assessment" key="2">
          <NewAIQuestionnaireClient client={client} />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  )
}

export default Questionnaire